import { FeatureGroup, Polyline, Tooltip, useMap } from "react-leaflet";
import { useQueryGtfsResourceById } from "../../Queries";
import { useContext, useEffect, useMemo, useRef } from "react";
import { ToolsContext } from "../../ToolsContext";


export function RoutePolylineLayer() {
    const tool = useContext(ToolsContext);
    const map = useMap();
    const GRoute = tool.propertyEditor.edit;
    const fgRef = useRef(null);
    const Polylines = [];
    const {isPending, error, data} = useQueryGtfsResourceById('shapes/route',GRoute.route_id,'both');

    /** nie rozumiem do końca, jak działa useMemo ani czy zależności dodane do tablicy są ok
     * (opierałem się na przykładach z dokumentacji), ale poniższy kod to handler eventu
     * wywoływanego po dodaniu FeatureGroup do mapy. Pozwala na wycentrowanie mapy na naszej trasie.
     */
    const fgHandlers = useMemo(
        () => ({
            add() {
                if (Polylines.length > 0) {
                    map.fitBounds(fgRef.current.getBounds());
                }
            }
        }),[map, fgRef.current, Polylines]
    ); 

    if (isPending || error || !data) {
        return <></>
    }

    const options = { color: '#' + GRoute.route_color, weight: 5, opacity: 1 };
    const variantOptions = { color: '#' + GRoute.route_color, weight: 2, dashArray: [5,15] }

    data.forEach((element) => {
        let first = true;
        for (const [key, value] of Object.entries(element)) {
            Polylines.push(<Polyline key={key} positions={value} pathOptions={(first) ? options : variantOptions}></Polyline>)
            first = false;
        }
    })

    return (
        <FeatureGroup ref={fgRef} key={GRoute.route_id} eventHandlers={fgHandlers}>
            {Polylines}
        </FeatureGroup>
    );
}
